import { render, staticRenderFns } from "./QTableDetail.vue?vue&type=template&id=6be8f399&scoped=true"
import script from "./QTableDetail.vue?vue&type=script&lang=js"
export * from "./QTableDetail.vue?vue&type=script&lang=js"
import style0 from "./QTableDetail.vue?vue&type=style&index=0&id=6be8f399&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be8f399",
  null
  
)

export default component.exports